import { FC, PropsWithChildren } from "react";

export type BoxProps = Partial<React.CSSProperties> & {
  className?: string;
};

const Box: FC<PropsWithChildren<BoxProps>> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <div style={rest} className={className}>
      {children}
    </div>
  );
};

export default Box;
